// Navigate the browser only to same-origin paths or absolute http(s) URLs.
// Rejects javascript:, data:, vbscript: and other script-capable schemes so a
// tainted value (e.g. an API response or URL param) can't trigger XSS when
// assigned to window.location.

// Returns a safe http(s) or same-origin target, or null if the value is unsafe.
export function sanitizeExternalUrl(target: string | null | undefined): string | null {
  if (!target) return null;
  const raw = String(target).trim();

  // Relative paths (same-origin) are always allowed ("/foo", but not "//evil.com").
  if (raw.startsWith('/') && !raw.startsWith('//')) return raw;

  try {
    const url = new URL(raw, window.location.origin);
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.href;
  } catch {
    /* fall through */
  }
  return null;
}

export function safeRedirect(target: string | null | undefined): boolean {
  const safe = sanitizeExternalUrl(target);
  if (safe) {
    window.location.href = safe;
    return true;
  }
  return false;
}

// window.open() only if `target` is safe. Returns the handle, or null if rejected.
export function safeOpen(
  target: string | null | undefined,
  features = 'noopener,noreferrer',
): Window | null {
  const safe = sanitizeExternalUrl(target);
  if (!safe) return null;
  return window.open(safe, '_blank', features);
}
